var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-group', {
    staticClass: "keyword-list-input",
    attrs: {
      "label": _vm.label,
      "errors": _vm.internalErrors
    },
    on: {
      "focus": _vm.focus
    }
  }, [_c('multiselect', {
    ref: "primaryInput",
    attrs: {
      "placeholder": _vm.placeholder,
      "options": _vm.knownTags,
      "value": _vm.internalValue,
      "clear-on-select": true,
      "hide-selected": false,
      "multiple": true,
      "disabled": _vm.disabled,
      "select-label": _vm.$t('hints.select'),
      "deselect-label": _vm.$t('hints.deselect'),
      "selected-label": _vm.$t('hints.selected'),
      "tag-placeholder": _vm.$t('hints.tag'),
      "taggable": true
    },
    on: {
      "search-change": _vm.onSearchChange,
      "remove": _vm.onRemove,
      "tag": _vm.onAdd,
      "select": _vm.onSelect,
      "open": function($event) {
        _vm.$emit('open')
      },
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [(!_vm.searchTerm && _vm.knownTags.length === 0) ? _c('span', {
    staticClass: "multiselect__no-options",
    slot: "beforeList"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('hints.noOptions')) + "\n    ")]) : _vm._e()])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b3e0544","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/KeywordListInput.vue
// module id = 1975
// module chunks = 0